export interface MyAccountDto
{
    getMsisdn(): string;
    getUserName(): string;
    getCategories(): string[];
    getProfileImage(): string;
}

export class MyAccountDtoImpl implements MyAccountDto
{
    private msisdn: string;
    private userName: string;
    private categories: string[];
    private profileImage: string;

    getCategories(): string[] {
        return this.categories;
    }

    setCategories(categories: string[])
    {
        this.categories =  categories;
    }
    getProfileImage(): string {
        return this.profileImage;
    }
    setProfileImage(profileImage: string) {
        return this.profileImage;
    }
    getMsisdn(): string 
    {
        return this.msisdn;
    }
    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }
  
    getUserName(): string 
    {
        return this.userName;
    }
    setUserName(userName: string)
    {
        this.userName = userName;
    }

   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/myaccount/myaccountdto.ts